document.addEventListener('DOMContentLoaded', async function () {
    console.log("Script initialized");

    const hiddenVariantElement = document.querySelector('.hide_variant_id');
    let hiddenVariantId = hiddenVariantElement ? hiddenVariantElement.value : null;

    // Store hidden variant ID in localStorage when on product page
    if (hiddenVariantId) {
        try {
            localStorage.setItem('hiddenVariantId', hiddenVariantId);
            console.log(`Stored hidden variant ID: ${hiddenVariantId}`);
        } catch (e) {}
    } else {
        // Retrieve hiddenVariantId when not on product page
        try {
            hiddenVariantId = localStorage.getItem('hiddenVariantId');
            console.log(`Retrieved hidden variant ID from storage: ${hiddenVariantId}`);
        } catch (e) {}
    }

    if (!hiddenVariantId) {
        console.log(" No hiddenVariantId found. Exiting script.");
        return;
    }

    /**
     * Fetch cart data using Zipify OCU API and check if hidden variant is in cart
     */
    async function checkCartForHiddenVariant() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            const productInCart = cart.items.some(item => String(item.variant_id) === hiddenVariantId);
            console.log(`Is hidden product in cart? ${productInCart}`);

            return productInCart;
        } catch (error) {
            console.error(" Error fetching cart data:", error);
            return false;
        }
    }

    /**
     * Disable Add to Cart button and Quantity buttons if hidden variant is in cart
     */
    async function disableButtonsIfProductInCart() {
        const isProductInCart = await checkCartForHiddenVariant();

        // Disable quantity controls on **Product Page** if needed
        const productPageInput = document.querySelector('input[name="id"]');
        if (productPageInput && productPageInput.value === hiddenVariantId) {
            document.querySelectorAll('.ocu-quantity-plus, .ocu-quantity-minus, .quantity__button').forEach(button => {
                button.disabled = true;
            });

            // Disable Add to Cart button for this product
            const productPageAddToCart = document.querySelector('.product-form__submit');
            if (productPageAddToCart) {
                productPageAddToCart.disabled = isProductInCart;
                productPageAddToCart.textContent = isProductInCart ? "Already in Cart" : "Add to Cart";
                console.log(`Add to Cart button disabled: ${isProductInCart}`);
            }
        }

        // Disable quantity controls on **Cart Page & Cart Drawer**
        const cartItems = document.querySelectorAll('.ocu-cart-line-item-wrapper');
        cartItems.forEach(item => {
            const productLink = item.querySelector('a.ocu-cart-line-item-image, a.ocu-cart-line-item-product-title');
            if (productLink) {
                const variantId = new URL(productLink.href, window.location.origin).searchParams.get('variant');
                if (variantId === hiddenVariantId) {
                    item.querySelectorAll('.ocu-quantity-plus, .ocu-quantity-minus, .quantity__button').forEach(button => {
                        button.disabled = true;
                    });
                    console.log(`Disabled quantity controls for product ${hiddenVariantId} in cart`);
                }
            }
        });
    }

    /**
     * Handle Add to Cart with Zipify OCU API
     */
    Zipify.OCU.api.customAddToCartEventHandler = async (button) => {
        console.log("Custom Add to Cart triggered");

        const productData = Zipify.OCU.api.getCustomAddToCartData?.() ?? {};
        if (productData.id === hiddenVariantId) {
            console.log("Restricted product attempted to be added. Preventing.");
            return; // Block adding the product more than once
        }

        button.disabled = false;
        button.click(); // Alternatively: button.dispatchEvent(new PointerEvent('click', { cancelable: true, bubbles: true }));

        setTimeout(disableButtonsIfProductInCart, 1000); // Check cart after adding
    };

    /**
     * Observe Cart Drawer Open Event
     */
    function observeCartDrawer() {
        const observer = new MutationObserver(() => {
            if (document.body.classList.contains('ocu-overflow-hidden')) {
                console.log("🛒 Cart drawer opened. Running check...");
                disableButtonsIfProductInCart();
            }
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    /**
     * Override Zipify Add to Cart Fetch
     */
    Zipify.OCU.api.customAddToCartFetch = async ({ url, method, data }) => {
        try {
            const body = JSON.stringify(data);
            const options = { method, body, headers: { 'Content-Type': 'application/json' } };

            const response = await fetch(url, options);
            const cart = await response.json();

            setTimeout(disableButtonsIfProductInCart, 1000); // Run check after cart update
            return { data: cart };
        } catch (e) {
            return Promise.reject(e);
        }
    };

    /**
     * Run checks on every page load (even non-product pages)
     */
    await disableButtonsIfProductInCart();
    observeCartDrawer();

    // Listen for Zipify cart open event
    document.addEventListener('ocu:cart:open', () => {
        console.log("🛒 Detected ocu:cart:open event. Checking cart...");
        disableButtonsIfProductInCart();
    });

    // Listen for clicks on Add to Cart button
    document.addEventListener('click', event => {
        const clickedButton = event.target.closest('.product-form__submit');
        if (clickedButton) {
            console.log("Add to Cart button clicked. Running cart validation...");
            setTimeout(disableButtonsIfProductInCart, 1000);
        }
    });

    // Check for cart updates even on collection/home pages
    setInterval(disableButtonsIfProductInCart, 5000);
});
/* drawer js */
document.addEventListener('DOMContentLoaded', () => {

const drawer = document.querySelector('.menu-drawer-container');
const closeBtn = document.querySelector('.drawer-close');
const overlay = document.querySelector('.drawer-overlay');
const drawerPanel = document.querySelector('.custom-menu-drawer');
const details = document.querySelectorAll('.drawer-details');

if (!drawer) return;

// Portal drawer/overlay to body so fixed z-index is not trapped in the header stacking context.
// Keeps slide animation smooth (no header z-index thrash on open/close).
if (overlay && overlay.parentElement !== document.body) {
  document.body.appendChild(overlay);
}
if (drawerPanel && drawerPanel.parentElement !== document.body) {
  document.body.appendChild(drawerPanel);
}

function lockDrawerScroll() {
  document.body.classList.add('overflow-hidden');
}

function unlockDrawerScroll() {
  document.body.classList.remove('overflow-hidden');
}

function resetHeaderDrawerChrome() {
  drawer.classList.remove('menu-opening');
  document.querySelector('.section-header')?.classList.remove('menu-open');
  const summary = drawer.querySelector('summary');
  summary?.setAttribute('aria-expanded', 'false');
  if (typeof removeTrapFocus === 'function') removeTrapFocus(summary);
}

details.forEach((detail) => {
  detail.querySelector('.drawer-submenu')?.setAttribute('hidden', '');
});

function setDrawerSubmenuVisible(submenu, visible) {
  if (!submenu) return;

  if (visible) {
    submenu.removeAttribute('hidden');
    submenu.style.removeProperty('display');
    submenu.style.removeProperty('visibility');
    submenu.style.removeProperty('opacity');
    submenu.style.removeProperty('transform');
    submenu.style.removeProperty('pointer-events');
  } else {
    submenu.setAttribute('hidden', '');
    submenu.style.setProperty('display', 'none', 'important');
    submenu.style.setProperty('visibility', 'hidden', 'important');
    submenu.style.setProperty('opacity', '0', 'important');
    submenu.style.setProperty('transform', 'translate3d(200vw, 0, 0)', 'important');
    submenu.style.setProperty('pointer-events', 'none', 'important');
  }
}

const drawerAccordionQuery = window.matchMedia('(max-width: 433px)');
const drawerCompactQuery = window.matchMedia('(max-width: 374px)');

function activateDrawerDetails(activeDetail) {
  details.forEach((detail) => {
    const submenu = detail.querySelector('.drawer-submenu');
    const isActive = detail === activeDetail;

    detail.classList.toggle('is-active', isActive);
    detail.classList.remove('menu-opening');

    if (isActive) {
      detail.setAttribute('open', '');
      setDrawerSubmenuVisible(submenu, true);
    } else {
      detail.removeAttribute('open');
      detail.open = false;
      setDrawerSubmenuVisible(submenu, false);
    }
  });

  const drawerLeft = drawerPanel?.querySelector('.drawer-left');
  if (drawerLeft) {
    drawerLeft.style.setProperty('transform', 'translateZ(0)');
    void drawerLeft.offsetHeight;
    drawerLeft.style.removeProperty('transform');
  }

  if (activeDetail && drawerAccordionQuery.matches) {
    requestAnimationFrame(() => {
      activeDetail.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }
}

// OPEN FIRST MENU BY DEFAULT
drawer.addEventListener('toggle', function () {
  if (drawer.hasAttribute('open')) {
    document.body.classList.add('menu-drawer-open');
    lockDrawerScroll();
    const firstDetail = document.querySelector('.drawer-details');
    activateDrawerDetails(drawerCompactQuery.matches ? null : firstDetail);
  } else {
    document.body.classList.remove('menu-drawer-open');
    unlockDrawerScroll();
    resetHeaderDrawerChrome();
    activateDrawerDetails(null);
  }
});

// CLOSE DRAWER
function closeDrawer() {
  drawer.removeAttribute('open');
  document.body.classList.remove('menu-drawer-open');
  unlockDrawerScroll();
  resetHeaderDrawerChrome();
  activateDrawerDetails(null);
}

closeBtn?.addEventListener(
  'click',
  (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    closeDrawer();
  },
  true
);

overlay?.addEventListener('click', closeDrawer);

// When HeaderDrawer starts its delayed close (removes menu-opening, keeps open ~400ms),
// hide the portaled overlay/panel immediately so they don't linger.
drawer.querySelector('summary.header__icon--menu')?.addEventListener('click', () => {
  const wasOpen = drawer.hasAttribute('open');
  if (!wasOpen) return;
  requestAnimationFrame(() => {
    if (
      drawer.hasAttribute('open') &&
      !drawer.classList.contains('menu-opening') &&
      document.body.classList.contains('menu-drawer-open')
    ) {
      document.body.classList.remove('menu-drawer-open');
      unlockDrawerScroll();
      activateDrawerDetails(null);
    }
  });
});

// ONLY ONE MENU OPEN — intercept touch before Safari native <details> toggle
let lastDrawerSelectAt = 0;
let lastDrawerSelectItem = null;

details.forEach((item) => {
  const summary = item.querySelector('.drawer-summary');
  if (!summary) return;

  const selectDrawerItem = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const now = performance.now();
    if (item === lastDrawerSelectItem && now - lastDrawerSelectAt < 500) return;
    lastDrawerSelectAt = now;
    lastDrawerSelectItem = item;

    const wasActive = item.classList.contains('is-active');
    activateDrawerDetails(wasActive ? null : item);
  };

  summary.addEventListener(
    'touchstart',
    (event) => {
      selectDrawerItem(event);
    },
    { capture: true, passive: false }
  );

  summary.addEventListener('click', (event) => {
    if (event.pointerType === 'touch') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    selectDrawerItem(event);
  }, true);

  item.addEventListener('toggle', () => {
    const shouldBeActive = item.classList.contains('is-active');
    if (item.open !== shouldBeActive) {
      if (shouldBeActive) {
        activateDrawerDetails(item);
      } else {
        item.open = false;
        setDrawerSubmenuVisible(item.querySelector('.drawer-submenu'), false);
      }
    }
  });
});

});
/* drawer js */

/* homepage steps fade in and fade out */
document.addEventListener('DOMContentLoaded', () => {

  if(window.innerWidth > 767) return;

  const steps = document.querySelectorAll(
    '.tw_why_comparison .tw-step'
  );

  const observer = new IntersectionObserver((entries) => {

    entries.forEach((entry) => {

      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.remove('is-visible');
      }

    });

  }, {
    threshold:0.45
  });

  steps.forEach((step) => {
    observer.observe(step);
  });

});
/* homepage steps fade in and fade out */